import React, { useCallback } from 'react'
import ReactSelect from 'react-select'

const styles = {
  groupStyles: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  styles: {
    container: base => ({
      ...base,
      flex: 1,

    }),
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      height: '40px',
      borderColor: '#EBEBEB',
      borderRadius: 4,
      '&:hover': {
        borderColor: '#EBEBEB'
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 8px',
      marginTop: '-1px'
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      maxHeight: '40px'
    })
  }
}

const Select = ({ classNameParent, text, size, icon, onChange, value, defaultValue, className, options, append, disabled, showNA, afterContent, ...props }) => {
  const propValue = useCallback(() => {
    return defaultValue ? { defaultValue } : { value }
  }, [defaultValue, value])

  return (<div className={classNameParent}>
    <small className="text-muted">{text}</small>
    <div className={'input-group input-group-' + size}>
      {icon ? <div className="input-group-prepend">
        <div className="input-group-text"><i className={icon}></i></div>
      </div> : ''}
      <ReactSelect
        styles={styles.styles}
        options={[
          ...(showNA ? [{ value: '', label: 'N/A' }] : []),
          ...options
        ]}
        {...propValue()}
        onChange={e => onChange(e)}
        formatGroupLabel={data => {
          return <div style={styles.groupStyles}>
            <span>{data.label}</span>
            <span style={styles.groupBadgeStyles}>{data.options.length}</span>
          </div>
        }}
        placeholder="N/A"
        isDisabled={disabled}
        {...props}
      />
      <div className="input-group-append">
        {React.Children.toArray(append)}
      </div>
    </div>
    {afterContent}
  </div>)
}

Select.defaultProps = {
  size: 'lg',
  icon: '',
  classNameParent: 'col-12',
  required: false,
  append: [],
  options: [],
  onChange: () => { },
  disabled: false,
  showNA: true,
  afterContent: ''
}

export default Select